<template>
  <b-modal size="md" hide-footer v-model="show" title="Cadastro do E-mail da Unidade Administrativa" @hidden="cancelar">
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageUnidadeAdministrativa
          :prefix="prefix + title + ' > '"
          v-model="form.departamento"
          @onselect="handleSelectDepartamento"
          label="Unidade Administrativa:*"
          podeApagarDepartamento="false"
        />
      </b-form-group>

      <b-form-row>
        <lg-form-input v-model="form.email" label="Email:*" cols="12" required />
      </b-form-row>

      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import Swal from "sweetalert2";

export default {
  components: {
    LgFormInput,
    LgFinderPageUnidadeAdministrativa,
  },
  props: {
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: true,
      form: {
        departamento: null,
        email: "",
      },
      title: "Cadastro"
    };
  },
  methods: {
    handleSelectDepartamento(departamento) {
      this.form.departamento = departamento;
    },
    async salvar() {
      if (!this.form.departamento || !this.form.email) {
        this.$bvToast.toast("Preencha todos os campos", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const payload = {
        departamentoId: this.form.departamento.id,
        email: this.form.email,
      };

      try {
        await ConfiguracaoSistemaService.cadastrarDepartamentoEmail(payload);
        this.$emit("salvo");
        this.cancelar();
        await Swal.fire({
          title: "Sucesso",
          text: "Salvo com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Erro ao salvar e-mail:", error);
        this.$bvToast.toast("Erro ao salvar e-mail", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
  },
};
</script>
